var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"color":"royalblue","font-size":"36px"}},[_vm._v("100000008818888")])}
var staticRenderFns = []

export { render, staticRenderFns }